/**
 * Lazy load video
 * Platform video JS is not loaded until users click on the image place holders
 * When users click on video icon on an image, we hide that image and inject
 * class name platformPlayer into the DOM, and then we initialize Video JS loader
 */
class LazyLoadVideo {

    constructor() {

        this.loader = null;
    }

    /**
     *  initialize the video loader
     */
    initVideoLoader() {
        //get global criticalVideoLoader for the first time init
        this.loader = this.loader || window.criticalVideoLoader;

        if ( this.loader !== 'undefined') {

            //get video config data.
            let configData = this.loader.getVideoElementsData().map((data) => { return data; });

            if ( configData ) {
                if (typeof FDM_Player !== 'undefined') {
                    this.loader.loadVideos(FDM_Player, configData);
                } else {
                    this.loader.loadScript(this.loader.loadVideos.bind(this.loader), configData);
                }
            }
        }

    }

    /**
     * EventListener when users click on video player icon on an image
     * @param event
     */
    toggleVideoPlayer(event) {

        event.stopPropagation();
        event.preventDefault();

        let elem = event.currentTarget;
        let imageHolder = elem.children[0];
        let fsPlayer = elem.children[1];
        let platformPlayer = fsPlayer.querySelector('.gallery-video-player');

        //only run this block code if the platformPlayer is not rendered yet, meaning there is no 'tpPlayer' class name
        if (!platformPlayer.classList.contains('tpPlayer')) {
            //hide the image
            imageHolder.style.display = 'none';
            //show the video player
            platformPlayer.style.display = 'block';
            /**
             * inject platformPlayer class name into the DOM
             * class selector platformPlayer is what video loader looks for to initialize the video
             */
            platformPlayer.classList.add('platformPlayer');

            //start the video
            this.initVideoLoader();
        }
    }

    /**
     * initialize click event on all video placeholders
     */
    addClickListeners(selector) {

        if ( selector ) {
            let count = selector.length;

            //if there are video place holders, wire click event listeners
            if ( count > 0 ) {
                for (let i = 0; i < count; i++) {
                    selector[i].addEventListener('click', this.toggleVideoPlayer.bind(this));
                }
            }
        }

    }
}

export default new LazyLoadVideo();


// WEBPACK FOOTER //
// ./assets/components/platformPlayer/LazyloadVideo.js